import { action } from 'typesafe-actions';
import {
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RECOVER_PASSWORD_FAILURE,
  RECOVER_PASSWORD_REQUEST,
  RECOVER_PASSWORD_SUCCESS,
  VERIFY_FAILURE,
  VERIFY_REQUEST,
  VERIFY_SUCCESS,
  REFRESH_WALLET_REQUEST,
  REFRESH_WALLET_SUCCESS,
  REFRESH_WALLET_FAILURE,
  USER_PREMIUM_PLANS_REQUEST,
  USER_PREMIUM_PLANS_SUCCESS,
  USER_PREMIUM_PLANS_FAILURE,
} from '../../constants/me';

export const verifyFailureAction = (e: any) => action(VERIFY_FAILURE, e);
export const verifyRequestAction = (token: string) =>
  action(VERIFY_REQUEST, token);
export const verifySuccessAction = (payload: any) =>
  action(VERIFY_SUCCESS, payload);

export const refreshWalletRequestAction = () => action(REFRESH_WALLET_REQUEST);
export const refreshWalletSuccessAction = (wallet: object) =>
  action(REFRESH_WALLET_SUCCESS, wallet);
export const refreshWalletFailureAction = (e: any) =>
  action(REFRESH_WALLET_FAILURE, e);

export const getUserPremiumPlansRequestAction = (tipster_id: string) =>
  action(USER_PREMIUM_PLANS_REQUEST, tipster_id);
export const getUserPremiumPlansSuccessAction = (user_premium_plans: object) =>
  action(USER_PREMIUM_PLANS_SUCCESS, user_premium_plans);
export const getUserPremiumPlansFailureAction = (e: any) =>
  action(USER_PREMIUM_PLANS_FAILURE, e);

export const resetPasswordFailureAction = (e: any) =>
  action(RESET_PASSWORD_FAILURE, e);
export const resetPasswordRequestAction = (token: string) =>
  action(RESET_PASSWORD_REQUEST, token);
export const resetPasswordSuccessAction = (payload?: any) =>
  action(RESET_PASSWORD_SUCCESS, payload);

export const recoverPasswordFailureAction = (e: any) =>
  action(RECOVER_PASSWORD_FAILURE, e);
export const recoverPasswordRequestAction = (token: string) =>
  action(RECOVER_PASSWORD_REQUEST, token);
export const recoverPasswordSuccessAction = (payload: any) =>
  action(RECOVER_PASSWORD_SUCCESS, payload);

export const meActions = {
  refreshWalletFailureAction,
  refreshWalletRequestAction,
  refreshWalletSuccessAction,
  getUserPremiumPlansFailureAction,
  getUserPremiumPlansRequestAction,
  getUserPremiumPlansSuccessAction,
  verifyFailureAction,
  verifyRequestAction,
  verifySuccessAction,
  resetPasswordFailureAction,
  resetPasswordRequestAction,
  resetPasswordSuccessAction,
  recoverPasswordFailureAction,
  recoverPasswordRequestAction,
  recoverPasswordSuccessAction,
};
